const BodyModal = () => {
  return 'Dirígete a tu cuenta de correo electrónico para confirmar tu cuenta y finalizar tu registro. Recuerda revisar tu bandeja de spam.'
}

export default BodyModal